import React from 'react';

export const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M15.9279 3.33398H4.07238C3.87687 3.33544 3.68977 3.41375 3.55152 3.55201C3.41326 3.69026 3.33495 3.87736 3.3335 4.07287V15.9284C3.33495 16.1239 3.41326 16.311 3.55152 16.4493C3.68977 16.5875 3.87687 16.6659 4.07238 16.6673H10.4557V11.5118H8.72238V9.4951H10.4557V8.01176C10.4557 6.28954 11.5057 5.35065 13.0502 5.35065C13.5668 5.35065 14.0835 5.35065 14.6002 5.42843V7.22287H13.5391C12.7002 7.22287 12.5391 7.62287 12.5391 8.20621V9.48954H14.5391L14.2779 11.5062H12.5391V16.6673H15.9279C16.1235 16.6659 16.3106 16.5875 16.4488 16.4493C16.5871 16.311 16.6654 16.1239 16.6668 15.9284V4.07287C16.6654 3.87736 16.5871 3.69026 16.4488 3.55201C16.3106 3.41375 16.1235 3.33544 15.9279 3.33398Z"
      fill="white"
    />
  </svg>
);
